import { Component, Input } from '@angular/core';

import { MenuContentItem, MenuSection } from '@frontend/vanilla/core';
import { MenuItemComponent } from '@frontend/vanilla/features/menus';

@Component({
    imports: [MenuItemComponent],
    selector: 'vn-f-help-button',
    templateUrl: 'help-button.html',
})
export class HelpButtonComponent {
    @Input() item?: MenuContentItem;
    MenuSection = MenuSection;
}
